import React, {Component} from 'react';
import {IUsageResult} from "../../models/usage-analytics/IUsageResult";
import {IUsageArea} from "../../models/usage-analytics/ISchoolUsageSummary";
import {IUsageFact} from "../../models/usage-analytics/IUsageFact";
import { gradeToStatusColour } from './GradeColourConverter';

interface SchoolUsageFactsCardProps {
    title: string;
    area: IUsageArea;
    result: IUsageResult;
    facts: IUsageFact[];
}

interface SchoolUsageFactsCardState {
}


export class SchoolUsageFactsCard extends Component<SchoolUsageFactsCardProps, SchoolUsageFactsCardState> {
    static displayName = SchoolUsageFactsCard.name;

    constructor(props: SchoolUsageFactsCardProps) {
        super(props);

        this.state = {
        };
    }

    componentDidMount(): void {

    }

    componentDidUpdate(prevProps: Readonly<SchoolUsageFactsCardProps>, prevState: Readonly<SchoolUsageFactsCardState>, snapshot?: any): void {

    }

    
    render(): JSX.Element {
        
        const facts = this.props.facts.map((fact,index) => {

            let lineItems: JSX.Element | null = null;

            if (fact.items && fact.items.length > 0) {
                lineItems = (
                    <ul>
                        {fact.items.map(item => <li>{item}</li>)}
                    </ul>
                );
            }

            return (
                <div className={"usage-facts-card__fact"} key={index}>
                    <span>{fact.title}</span>
                    {lineItems}
                </div>
            );
        });
        
        const content = (
            <div className={"usage-facts-card__content"}>
                {facts}
            </div>
        );
        
        return (
            <div className="usage-facts-card">
                <div className={`usage-facts-card__area usage-facts-card__area--${gradeToStatusColour(this.props.result.grade)}`}>
                    <span>{this.props.title}</span>
                    <div className={`usage-facts-card__result`}>
                        <span>{this.props.result.grade !== "NoData" ? `${this.props.result.markPercentage}%` : ""}</span>
                        <span className={"text-extra-detail"}>{this.props.result.grade}</span>
                    </div>
                </div>
                {this.props.result.grade !== "NoData" ? content : null}
            </div>
        );
    }
}